import React from 'react';
import Typography from '@mui/material/Typography';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
  width: '100%',
}));

const ScaleContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: 8,
  padding: '0 4px',
}));

const ScaleItem = styled('button', {
  shouldForwardProp: (prop) => !['isSelected'].includes(prop),
})(({ theme, isSelected }) => ({
  flex: 1,
  height: 56,
  minWidth: 0,
  borderRadius: 16,
  border: isSelected ? `2px solid ${theme.palette.primary.main}` : '2px solid #e0e0e0',
  backgroundColor: isSelected ? theme.palette.primary.main : '#fff',
  color: isSelected ? '#fff' : theme.palette.grey[700],
  fontFamily: 'Rubik-Regular, system-ui, sans-serif',
  fontSize: 22,
  fontWeight: 700,
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'border-color 0.15s ease, background-color 0.15s ease, color 0.15s ease',
  '&:hover': {
    borderColor: theme.palette.primary.main,
  },
  [theme.breakpoints.down('sm')]: {
    height: 48,
    fontSize: 18,
  },
}));

const LabelsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  padding: '0 4px',
  marginTop: 4,
}));

const EndLabel = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.grey[500],
}));

// Calibration and Big Five share the API's 1–5 range. The scoring model
// also reverse-scores with 6 - value; a seven-point UI cannot be used here.
const SCALE_VALUES = [1, 2, 3, 4, 5];

export default function EmojiLikertScale({
  value,
  onChange,
  leftLabel,
  rightLabel,
  disabled = false,
}) {
  const { t } = useTranslation();
  const left = leftLabel ?? t('Assessment.likertStronglyDisagree');
  const right = rightLabel ?? t('Assessment.likertStronglyAgree');
  return (
    <Container>
      <ScaleContainer>
        {SCALE_VALUES.map((v) => (
          <ScaleItem
            key={v}
            type="button"
            isSelected={value === v}
            onClick={() => !disabled && onChange(v)}
            disabled={disabled}
          >
            {v}
          </ScaleItem>
        ))}
      </ScaleContainer>
      <LabelsContainer>
        <EndLabel>{left}</EndLabel>
        <EndLabel>{right}</EndLabel>
      </LabelsContainer>
    </Container>
  );
}
